export default {
  aigc_gptTranslator_title: 'GPT Translator',
  aigc_gptTranslator_game_type: 'Genre-Game',
  aigc_gptTranslator_input_plearhost: 'Type or paste the text you want to translate',
  aigc_gptTranslator_translate: 'Translate',
  aigc_gptTranslator_stop: 'Stop',
  aigc_gptTranslator_empty: 'Empty',
  aigc_gptTranslator_no_translate: 'No Idea What to Translate? ',
  aigc_gptTranslator_try_text: 'Try Our Sample Text:',
  aigc_gptTranslator_demo_0: '{game_come}-{src}-{trg}-example',
  aigc_gptTranslator_demo_1: 'Genshine Intelligence Analysis Data',
  aigc_gptTranslator_copy_translation: 'Copy translation',
  aigc_gptTranslator_tips: `Under the "General" tab, the translation you see is GPT4's native output without extensive refinement. It's here for your experience and reference.`,
};
